const round = (number: string | number, precision?: number) => {
  const roundedNumber = Math.round(+number * 100) / 100;
  return precision !== undefined
    ? Number(roundedNumber.toFixed(precision))
    : roundedNumber;
};

export default round;
